import React, { useCallback, useMemo, useState } from "react";
import NavTabs from "~components/NavTabs";
import ClientesFilterBar from "../../components/ClientesFilterBar";
import WinLossChart from "../../components/WinLossChart";
import VendedorPerformanceTable from "../../components/VendedorPerformanceTable";
import { useClienteShareWinLossData } from "../../hooks/useClienteShareWinLossData";
import { useFatsData } from "../../hooks/useFatsData";
import { buildMesOptionsFromDados } from "../../utils/formatters";
import { filtrarLinhas } from "../../utils/buscaClientes";

const tabs = [
  { name: "Carteira", link: "/gestao-de-vendas/relatorio-de-vendas/carteira", className: "w-[200px]" },
  { name: "Clientes", link: "/gestao-de-vendas/relatorio-de-vendas/clientes", className: "w-[200px]" },
];

const ClientesPage = () => {
  const [searchValue, setSearchValue] = useState("");
  const [mesSelecionado, setMesSelecionado] = useState(null);
  const [grupoProduto, setGrupoProduto] = useState("todos");
  const [produto, setProduto] = useState("todos");

  const { listRows, filterOptions, updatedAt, mesesDeListagem, isRefreshing: refreshingFats } =
    useFatsData(mesSelecionado, { grupoProduto, produto });

  const mesOptions = useMemo(() => buildMesOptionsFromDados(mesesDeListagem), [mesesDeListagem]);
  const defaultMes = mesOptions[0]?.value ?? "";
  const mes = mesSelecionado ?? defaultMes;

  const { diminuiram, aumentaram, isRefreshing: refreshingShare } = useClienteShareWinLossData({
    grupoProduto,
    produto,
    mes,
  });

  const hasActiveFilters = mes !== defaultMes || grupoProduto !== "todos" || produto !== "todos" || searchValue !== "";

  const clearClientesFilters = useCallback(() => {
    setMesSelecionado(null);
    setGrupoProduto("todos");
    setProduto("todos");
    setSearchValue("");
  }, []);

  const { grupoOptions, produtoOptions, produtoToGrupo } = filterOptions ?? {};

  const produtoOptionsFiltradas = useMemo(() => {
    if (!produtoOptions) return [];
    if (!grupoProduto || grupoProduto === "todos") return produtoOptions;
    if (!produtoToGrupo) return produtoOptions;
    return produtoOptions.filter(
      (opt) => opt.value === "todos" || produtoToGrupo.get(opt.value) === grupoProduto
    );
  }, [produtoOptions, produtoToGrupo, grupoProduto]);


  React.useEffect(() => {
    if (produto === "todos") return;
    if (!produtoToGrupo) return;
    if (grupoProduto === "todos") return;
    if (produtoToGrupo.get(produto) !== grupoProduto) {
      setProduto("todos");
    }
  }, [grupoProduto, produto, produtoToGrupo]);

  const isRefreshing = refreshingShare || refreshingFats;

  const filteredRows = useMemo(() => filtrarLinhas(listRows, searchValue), [listRows, searchValue]);

  const winLossVazio = useMemo(() => {
    if (isRefreshing || diminuiram?.length || aumentaram?.length) return null;
    const label = mesOptions.find((opt) => opt.value === mes)?.label ?? mes;
    return `Sem dados de WinLoss para ${label}`;
  }, [isRefreshing, diminuiram, aumentaram, mes, mesOptions]);

  return (
    <>
      <NavTabs navs={tabs} centerTabs navBg="gray" />
      <div className="space-y-4 py-6">
      {isRefreshing && (
        <div className="container">
          <div className="w-[130px] flex mt-4 items-center gap-2 bg-[#01054C] rounded-md px-4 py-2 text-xs font-semibold text-[#fff] animate-pulse">
            <span className="rounded-full" />
            Atualizando...
          </div>
        </div>
      )}
        <ClientesFilterBar
          searchValue={searchValue}
          onSearchValueChange={setSearchValue}
          onSearchSubmit={setSearchValue}
          mesValue={mes}
          onMesChange={setMesSelecionado}
          mesOptions={mesOptions}
          grupoProdutoValue={grupoProduto}
          onGrupoProdutoChange={setGrupoProduto}
          grupoProdutoOptions={grupoOptions ?? []}
          produtoValue={produto}
          onProdutoChange={setProduto}
          produtoOptions={produtoOptionsFiltradas}
          showClearButton={hasActiveFilters}
          onClearFilters={clearClientesFilters}
        />
        <div className="container">
          <WinLossChart diminuiram={diminuiram} aumentaram={aumentaram} emptyMessage={winLossVazio} />
        </div>
        <VendedorPerformanceTable
          rows={filteredRows}
          updatedAt={updatedAt}
          expandirLinhas={!!searchValue.trim()}
        />
      </div>
    </>
  );
};

export default ClientesPage;
